import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import { Place as PlaceNew } from 'app/modules/place-map';
import Place from './place';
import PlaceDeleteDialog from './place-delete-dialog';
import PlaceDetail from './place-detail';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={PlaceNew} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={PlaceNew} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={PlaceDetail} />
      <ErrorBoundaryRoute path={match.url} component={Place} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={PlaceDeleteDialog} />
  </>
);

export default Routes;
